import * as React from "react";
import { Tooltip as TooltipPrimitive } from "radix-ui";
import { cn } from "@/libs/cn";

interface TooltipProps {
  children: React.ReactNode;
  label?: React.ReactNode;
  contentClassName?: string;
  disabled?: boolean;
  side?: "top" | "right" | "bottom" | "left";
}

const Tooltip = ({ children, label, contentClassName, disabled = false, side }: TooltipProps) => {
  if (disabled || !label) {
    return <>{children}</>;
  }

  return (
    <TooltipPrimitive.Provider delayDuration={300}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={5}
            className={cn(
              "z-50 max-w-[66vw] wrap-break-word select-none rounded bg-white",
              "px-3.75 py-2.5 text-xs leading-normal shadow-[hsl(206_22%_7%/35%)_0px_10px_38px_-10px,hsl(206_22%_7%/20%)_0px_10px_20px_-15px] will-change-[transform,opacity]",
              "data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade",
              contentClassName,
            )}
          >
            {label}
            <TooltipPrimitive.Arrow className="fill-white/75" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};

export default Tooltip;
